import { call, put, takeLatest } from "redux-saga/effects";

import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import { CarCareAppointment } from "../types";
import {
	GetCarCareAppointmentDetailPayload,
	getCarCareAppointmentDetailAsync,
	setCarCareAppointment,
} from "./car-care-appointment.slice";

// Get carCareAppointment detail
function* getCarCareAppointmentDetailSaga(
	action: PayloadAction<GetCarCareAppointmentDetailPayload>,
) {
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<CarCareAppointment>>(
				`/dashboard/bookings/car-wash-service/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setCarCareAppointment.type, payload: response });
		callback?.();
	} else {
		message.error(translate(error.message));
	}
}

function* watchCarCareAppointmentDetail() {
	yield takeLatest(
		getCarCareAppointmentDetailAsync,
		getCarCareAppointmentDetailSaga,
	);
}

const carCareAppointmentSaga = [watchCarCareAppointmentDetail()];
export default carCareAppointmentSaga;
